import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText from '../../../Core/RichText';

import {
  Card,
  ImageWrapper,
  Img,
  Content,
  PointsContainer,
  Heading,
  Body,
} from './styles';

const options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => {
      return <span>{children}</span>;
    },
  },
};

const PointsTile = ({ data = null, className = '' }) => {
  if (!data) return false;

  const {
    id,
    component,
    imageDam,
    bodyCopy,
    heading,
    pointsPreText,
    pointsValue,
    pointsPostText,
    cardClassName,
    backgroundColor,
  } = data;

  return (
    <Card
      key={id}
      className={`${component} ${className} ${cardClassName || ''}`}
      $backgroundColor={backgroundColor}
      role="listitem"
    >
      {imageDam && (
        <ImageWrapper>
          <Img src={imageDam} alt={imageDam.altText || ''} />
        </ImageWrapper>
      )}
      {bodyCopy && (
        <Content>
          {heading && (
            <Heading>
              <RichText document={heading} />
            </Heading>
          )}
          {pointsValue && (
            <PointsContainer>
              <p>
                {pointsPreText && <>{ReactHtmlParser(pointsPreText)}&nbsp;</>}
                {pointsValue && <>{ReactHtmlParser(pointsValue)}&nbsp;</>}
                {pointsPostText && <>{ReactHtmlParser(pointsPostText)}</>}
              </p>
            </PointsContainer>
          )}
          <Body>
            <RichText document={bodyCopy} options={options} />
          </Body>
        </Content>
      )}
    </Card>
  );
};

PointsTile.propTypes = {
  data: PropTypes.shape(),
  className: PropTypes.string,
};

export default PointsTile;
